export const getImageURL = (imageURL) => {
    const fullImageURL =
        imageURL?.startsWith("http://") || imageURL?.startsWith("https://") ? imageURL : `${process.env.REACT_APP_BACKEND_URL}${imageURL}`;
    return fullImageURL;
};
